module.exports = __webpack_public_path__ + "static/img/time.4c1e58c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time.png
// module id = qKtB
// module chunks = 1